import React from "react";
import { useEffect, useState } from "react";
import {
  CompetitorPriceGetProductAuto,
  ProductFilterProducts,
  CompetitorPriceSetRefProduct,
} from "../../Api/Services";
import { useParams } from "react-router-dom";
import ShowDeImg from "../../assets/Icon/icons8-details-50.png";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompetitorConnect() {
  const [isLoading, setLoading] = useState(true);
  const [ProductId, setProductId] = useState();
  const [ProductAuto, setProductAuto] = useState([]);
  const [GhosiId, setGhosiId] = useState();
  const [Search, setSearch] = useState({});
  const [Data, setData] = useState([]);
  let { id } = useParams();

  const start = async () => {
    try {
      const ProductFilterProductsData = await ProductFilterProducts({});
      if (
        ProductFilterProductsData.status &&
        ProductFilterProductsData.status === 200
      ) {
        setData(ProductFilterProductsData.data.data.data);
        const CompetitorPriceGetProductAutoData =
          await CompetitorPriceGetProductAuto(id);
        if (
          CompetitorPriceGetProductAutoData.status &&
          CompetitorPriceGetProductAutoData.status === 200
        ) {
          setProductAuto(CompetitorPriceGetProductAutoData.data.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const ShowProduct = async (id) => {
    setGhosiId(id);
  };

  const Add = async () => {
    setLoading(true);
    try {
      let model = {
        CompetitorId: id,
        ProductId: ProductId,
        ProductGhosiId: GhosiId,
      };
      const CompetitorPriceSetRefProductData =
        await CompetitorPriceSetRefProduct(model);
      if (
        CompetitorPriceSetRefProductData.status &&
        CompetitorPriceSetRefProductData.status === 200
      ) {
        start();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      setProductId();
      setGhosiId();
    }
  };

  const CheckDate = (date) => {
    const today = new Date();
    const inputDate = new Date(date);
    const diffInMilliseconds = Math.abs(today - inputDate);
    const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
    if (diffInDays > 1) return false;
    else return true;
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  const Searched = async () => {
    try {
      setLoading(true);
      const ProductFilterProductsData = await ProductFilterProducts({
        ...Search,
      });
      if (
        ProductFilterProductsData.status &&
        ProductFilterProductsData.status === 200
      ) {
        setData(ProductFilterProductsData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const ProductFilterProductsData = await ProductFilterProducts({});
      if (
        ProductFilterProductsData.status &&
        ProductFilterProductsData.status === 200
      ) {
        setData(ProductFilterProductsData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          {GhosiId && (
            <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
              <h6>{ProductAuto.find((e) => e.id == GhosiId).titlt}</h6>
              <div className="d-flex justify-content-start align-items-center flex-wrap">
                <InputCus
                  type="text"
                  name="name"
                  id="name"
                  text="نام"
                  className="m-2"
                  value={Search.name || ""}
                  onChange={handleChangeSearch}
                />
                <InputCus
                  type="text"
                  name="symbol"
                  id="symbol"
                  text="سیمبل"
                  className="m-2"
                  value={Search.symbol || ""}
                  onChange={handleChangeSearch}
                />
              </div>
              <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                <div onClick={Searched} className="btnSearch">
                  جست و جو
                </div>
                <div onClick={Clear} className="btnCancel">
                  بروزرسانی
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
                <table className="table">
                  <thead className="sticky-header">
                    <tr className="trTable">
                      <th>نام</th>
                      <th>سیمبل</th>
                    </tr>
                  </thead>
                  <tbody className="pointer">
                    {Data.slice(0, 5).map((item, key) => (
                      <tr
                        key={key}
                        onClick={() => setProductId(item.id)}
                        className={ProductId == item.id && "bg-success"}
                      >
                        <td>
                          {item.productBerandName} {item.name}{" "}
                          {item.productColorName} {item.productCountryName}
                        </td>
                        <td>
                          {item.productBerandName} {item.symbol}{" "}
                          {item.productColorName} {item.productCountryName}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-start align-items-center w-100 mb-3">
                <button onClick={Add} className="butAU">
                  ثبت
                </button>
              </div>
            </div>
          )}
          <>
            <div className="d-flex justify-content-center align-items-center w-100 tableC">
              <table className="table" style={{ lineHeight: "normal" }}>
                <thead className="sticky-header">
                  <tr className="trTable">
                    <th>نام کالا در مرجع</th>
                    <th>نام کالای</th>
                    <th>سیمبل کالای</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="identitystyle">
                  {ProductAuto &&
                    ProductAuto.map((itemPro, keyPro) => (
                      <tr
                        key={keyPro}
                        className={`${
                          CheckDate(itemPro.createdDate) && "bg-success"
                        }`}
                      >
                        <td>{itemPro.titlt}</td>
                        <td
                          className={itemPro.productIsActived == false && "bg-danger"}
                        >
                          {itemPro.productProductBerandName}{" "}
                          {itemPro.productName}{" "}
                          {itemPro.productProductColorName}{" "}
                          {itemPro.productProductCountryName}
                        </td>
                        <td
                          className={itemPro.productIsActived == false && "bg-danger"}
                        >
                          {itemPro.productProductBerandName}{" "}
                          {itemPro.productSymbol}{" "}
                          {itemPro.productProductColorName}{" "}
                          {itemPro.productProductCountryName}
                        </td>
                        <td>
                          <span
                            className="d-inline-block pointer me-2"
                            tabIndex="0"
                            data-bs-toggle="tooltip"
                            title="محصول"
                          >
                            <img
                              height="30"
                              src={ShowDeImg}
                              alt="محصول"
                              onClick={() => {
                                ShowProduct(itemPro.id);
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        </div>
      </div>
    </div>
  );
}
export default CompetitorConnect;
